import { render, staticRenderFns } from "./MarketplaceOrdersView.vue?vue&type=template&id=5a068afd"
import script from "./MarketplaceOrdersView.vue?vue&type=script&lang=js"
export * from "./MarketplaceOrdersView.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceOrdersView.vue?vue&type=style&index=0&id=5a068afd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports